export function getIntegrationsFilterOption({ options, value }) {
  return options.find(option => option.value === value) ?? options[0]
}
